import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function Layout({ children }) {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
